import services from '../../../../services';
import {
  calculateKPITop3,
  createTemporaryTables,
  dropTemporaryTables,
  formatCurrency,
} from '../shared';

export const PodiumMixin = {
  data() {
    return {
      temporaryTables: null,
      kpiData: null,
      top3Ranked: [],
      otherConsultants: [],
      kpiTop3Data: null,
      isLoading: false,
    };
  },
  methods: {
    getDateRange() {
      return {
        startDate: this.initialDate,
        endDate: this.finalDate,
      };
    },
    async fetchData(model, action) {
      this.isLoading = true;
      try {
        const { startDate, endDate } = this.getDateRange();

        const { data } = await services.post(model, action, {
          startDate,
          endDate,
          ...this.temporaryTables,
          ...this.dataSend,
        });

        this.top3Ranked = data.slice(0, 3);
        this.otherConsultants = data.slice(3);

        if (this.top3Ranked.length) {
          this.kpiTop3Data = calculateKPITop3(this.top3Ranked);
        }
        this.$emit('fetching', false);
      } catch (error) {
        return {
          errorMessage: 'Error fetching data:',
          error,
        };
      }
    },
    async fetchKpi() {
      this.isLoading = true;
      try {
        const model = 'annual-podium';
        const action = 'getKPIPodium';
        const { startDate, endDate } = this.getDateRange();
        const { tableName3 } = this.temporaryTables;

        const { data } = await services.post(model, action, {
          tableName3,
          startDate,
          endDate,
        });

        this.kpiData = {
          periodBilling: data.periodBilling,
          periodSales: data.periodSales,
          ticketAverage: data.ticketAverage,
          projectedAnnualBilling: data.projectedAnnualBilling,
        };
      } catch (error) {
        return {
          errorMessage: 'Erro ao buscar KPIs:',
          error,
        };
      }
    },
    async createTemporaryTables() {
      try {
        const { startDate, endDate } = this.getDateRange();

        this.temporaryTables = await createTemporaryTables(
          services,
          this.dataSend,
          startDate,
          endDate,
        );
      } catch (error) {
        return {
          errorMessage: 'Erro ao criar tabelas temporárias:',
          error,
        };
      }
    },
    async dropTemporaryTables() {
      if (this.temporaryTables) {
        await dropTemporaryTables(services, this.temporaryTables);
        this.temporaryTables = null;
      }
    },
    formatCurrencyStandard(value) {
      return formatCurrency(value);
    },
  },
};
